import { Enum_Feedback_Suggestedcategory } from '../__generated__/graphql';

/* ROUTERS  */
export const ROUTES = {
  MAIN: '/',
  LOGOUT: '/logout',
  SIGNUP: '/signup',
  LOGIN: '/login',
  FORGET_PASSWORD: '/forgot-password',
  RESET: '/reset-password',
  VERIFY: '/verify',
  AUTHENTICATION: '/authentication',
  PROFILE: '/profile',
  BOOK: '/book',
  SECTION: '/section',
};

export const TOKEN = 'TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const USER = 'USER';
export const REGULAR_DATE_FORMAT = 'DD/MM/YYYY';
export const BOOK_NAME = 'BOOK_NAME';

export const LIMIT = 10;

export const ERROR_PAGE_TITLE = 'Oops! An error occurred!';
export const ERROR_PAGE_SUBTITLE =
  'Something is broken. Please let us know what you were doing when this error occurred. We will fix it as soon as possible. Sorry for any inconvenience caused.';

export const REGEX = {
  NAME: /^[a-z ,.'-]+$/i,
  ZIPCODE: /^[0-9]{5,6}$/,
  CITY: /^[a-zA-Z]+(?:[\s-][a-zA-Z]+)*$/,
  WEB_URL:
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  PASSWORD: /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*]{8,16}$/,
  PHONE: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/,
  EMAIL:
    /^(([^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+(\.[^<>()[\]\\.,;:!#$*%^'`~={}?/&\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  AMOUNT: /^\d+$|^\d+\.\d*$/,
  OPTIONALNEGATIVEAMOUNT: /^[-]?\d+$|^[-]?\d+\.\d*$/,
  NUMBER: /^\d+$/,
  COUNTRY_CODE_PHONE: /^[0-9]{7,12}$/,
};

export const BREAKPOINTS = {
  mobile: 550,
  tablet: 767,
  desktop: 1000,
  hd: 1200,
};

export const COMPANY_INFO = { COOKIE_EXPIRY: 259200 };

export const SHOULD_GO_TO_NEXT_PAGE_AFTER_FEEDBACK_SUBMIT = true;

export const MAX_COMMENT_CHAR_LENGTH = 250;
export const MAX_COMMENT_FACT_CHECK_CHAR_LENGTH = MAX_COMMENT_CHAR_LENGTH;
export const MAX_COMMENT_CATEGORY_CHAR_LENGTH = MAX_COMMENT_CHAR_LENGTH;

export const CATEGORY_ANALYSIS_CATEGORY_LABEL = {
  [Enum_Feedback_Suggestedcategory.GenderAndSexuality]: 'Gender & Sexuality',
  [Enum_Feedback_Suggestedcategory.RacialAndEthnicJustice]:
    'Racial & Ethnic Justice',
  [Enum_Feedback_Suggestedcategory.None]: 'None',
};

export const FIRST_PERSON_PERSPECTIVE_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const PHYSICAL_CONTACT_OPTIONS = [
  { label: 'No Contact', value: 'No Contact' },
  { label: 'Friendly Touch', value: 'Friendly Touch' },
  { label: 'Accidental Touch', value: 'Accidental Touch' },
  { label: 'Comforting Touch', value: 'Comforting Touch' },
  { label: 'Romantic Touch', value: 'Romantic Touch' },
  { label: 'Suggestive Touch', value: 'Suggestive Touch' },
  { label: 'Kissing', value: 'Kissing' },
  { label: 'Intimate Contact', value: 'Intimate Contact' },
  { label: 'Unknown', value: 'Unknown' },
];

export const SETTING_OPTIONS = [
  { label: 'School', value: 'School' },
  { label: 'Classroom', value: 'Classroom' },
  { label: 'Locker Room', value: 'Locker Room' },
  { label: 'Bathroom', value: 'Bathroom' },
  { label: 'Bedroom', value: 'Bedroom' },
  { label: 'Hallway', value: 'Hallway' },
  { label: 'Dorm Room', value: 'Dorm Room' },
  { label: 'Home', value: 'Home' },
  { label: 'Living Room', value: 'Living Room' },
  { label: 'Basement', value: 'Basement' },
  { label: 'Public Space', value: 'Public Space' },
  { label: 'Park', value: 'Park' },
  { label: 'Car', value: 'Car' },
  { label: 'Bus', value: 'Bus' },
  { label: 'Train', value: 'Train' },
  { label: 'Library', value: 'Library' },
  { label: 'Hospital', value: 'Hospital' },
  { label: 'Clinic', value: 'Clinic' },
  { label: 'Doctor’s Office', value: 'Doctor’s Office' },
  { label: 'Gym', value: 'Gym' },
  { label: 'Pool', value: 'Pool' },
  { label: 'Shower', value: 'Shower' },
  { label: 'Hotel Room', value: 'Hotel Room' },
  { label: 'Campground', value: 'Campground' },
  { label: 'Beach', value: 'Beach' },
  { label: 'Forest', value: 'Forest' },
  { label: 'Closet', value: 'Closet' },
  { label: 'Changing Room', value: 'Changing Room' },
  { label: 'Storage Room', value: 'Storage Room' },
  { label: 'Office', value: 'Office' },
  { label: 'Unknown', value: 'Unknown' },
];

export const EXPLICIT_TERMS_FOUND_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const ANATOMICAL_TERMS_PRESENT_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const CONTAINS_DIALOGUE_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const CHROMOSOMALLY_DEFINED_GENDER_OPTIONS = [
  { label: 'Unknown', value: 'unknown' },
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
];

export const SELF_IDENTIFIED_GENDERS_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'Other', value: 'Other' },
  { label: 'Non-Binary', value: 'Non-Binary' },
  { label: 'Genderqueer', value: 'Genderqueer' },
  { label: 'Trans', value: 'Trans' },
  { label: 'Genderfluid', value: 'Genderfluid' },
  { label: 'Agender', value: 'Agender' },
  { label: 'Bigender', value: 'Bigender' },
  { label: 'Demigender', value: 'Demigender' },
  { label: 'Two-Spirit', value: 'Two-Spirit' },
  { label: 'Pangender', value: 'Pangender' },
  { label: 'Genderflux', value: 'Genderflux' },
  { label: 'Androgyne', value: 'Androgyne' },
  { label: 'Xenogender', value: 'Xenogender' },
  { label: 'Transmasculine', value: 'Transmasculine' },
  { label: 'Transfeminine', value: 'Transfeminine' },
  { label: 'Multigender', value: 'Multigender' },
  { label: 'Gender Nonconforming', value: 'Gender Nonconforming' },
];

export const SEXUAL_RELATIONSHIP_TYPE_OPTIONS = [
  { label: 'Heterosexual', value: 'Heterosexual' },
  { label: 'Homosexual', value: 'Homosexual' },
  { label: 'Bisexual', value: 'Bisexual' },
  { label: 'Pansexual', value: 'Pansexual' },
  { label: 'Asexual', value: 'Asexual' },
  { label: 'Queer', value: 'Queer' },
  { label: 'Polyamorous', value: 'Polyamorous' },
  { label: 'Monogamous', value: 'Monogamous' },
  { label: 'Non-Specified', value: 'Non-Specified' },
  { label: 'None', value: 'None' },
];

export const MIRACLE_MENTIONED_HOW_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'Implied', value: 'Implied' },
  { label: 'Asserted as Fact', value: 'Asserted as Fact' },
];

export const EXPLICIT_OR_IMPLICIT_OPTIONS = [
  { label: 'None', value: 'None' },
  { label: 'Implicit', value: 'Implicit' },
  { label: 'Explicit', value: 'Explicit' },
];

export const WHO_SAYS_IT_OPTIONS = [
  { label: 'Attributed', value: 'Attributed' },
  { label: 'UnAttributed', value: 'UnAttributed' },
  { label: 'Mixed', value: 'Mixed' },
];

export const RT_TONE_OPTIONS = [
  { label: 'Academic', value: 'Academic' },
  { label: 'Devotional', value: 'Devotional' },
  { label: 'Polemic', value: 'Polemic' },
  { label: 'Narrative', value: 'Narrative' },
];

export const CHARACTER_AGE_OPTIONS = [
  { label: 'Minor', value: 'Minor' },
  { label: 'Adult', value: 'Adult' },
  { label: 'Unknown', value: 'Unknown' },
];

export const POWER_IMBALANCE_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const TONE_OPTIONS = [
  { label: 'Romantic', value: 'Romantic' },
  { label: 'Suggestive', value: 'Suggestive' },
  { label: 'Tense', value: 'Tense' },
  { label: 'Dark', value: 'Dark' },
  { label: 'Tender', value: 'Tender' },
  { label: 'Playful', value: 'Playful' },
  { label: 'Flirty', value: 'Flirty' },
  { label: 'Authoritative', value: 'Authoritative' },
  { label: 'Humorous', value: 'Humorous' },
  { label: 'Ironic', value: 'Ironic' },
  { label: 'Reflective', value: 'Reflective' },
  { label: 'Emotional', value: 'Emotional' },
  { label: 'Neutral', value: 'Neutral' },
];

export const TRUE_FALSE_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const NUDITY_DETECTED_OPTIONS = [
  { label: 'none', value: 'none' },
  { label: 'general', value: 'general' },
  { label: 'non-sexual', value: 'non-sexual' },
  { label: 'sexual', value: 'sexual' },
];

export const NUDITY_EXTENT_OPTIONS = [
  { label: 'not implied', value: 'not implied' },
  { label: 'subtly implied', value: 'subtly implied' },
  { label: 'explicit', value: 'explicit' },
];

export const NUDITY_TYPE_OPTIONS = [
  { label: 'none', value: 'none' },
  { label: 'clingy', value: 'clingy' },
  { label: 'revealing', value: 'revealing' },
  { label: 'sheer', value: 'sheer' },
  { label: 'partial', value: 'partial' },
  { label: 'top', value: 'top' },
  { label: 'rear', value: 'rear' },
  { label: 'side', value: 'side' },
  { label: 'frontal', value: 'frontal' },
  { label: 'full', value: 'full' },
];

export const SEXUAL_ACTS_DETECTED_OPTIONS = [
  { label: 'none', value: 'none' },
  { label: 'flirting', value: 'flirting' },
  { label: 'romantic touching', value: 'romantic touching' },
  { label: 'kissing', value: 'kissing' },
  { label: 'passionate kissing', value: 'passionate kissing' },
  { label: 'caressing', value: 'caressing' },
  { label: 'fondling', value: 'fondling' },
  { label: 'undressing', value: 'undressing' },
  { label: 'suggestive posing', value: 'suggestive posing' },
  { label: 'intimate touching', value: 'intimate touching' },
  { label: 'heavy petting', value: 'heavy petting' },
  { label: 'oral stimulation', value: 'oral stimulation' },
  { label: 'manual stimulation', value: 'manual stimulation' },
  { label: 'penetrative intercourse', value: 'penetrative intercourse' },
  {
    label: 'non-penetrative intercourse',
    value: 'non-penetrative intercourse',
  },
  { label: 'group intimacy', value: 'group intimacy' },
  { label: 'kink exploration', value: 'kink exploration' },
  { label: 'explicit erotic act', value: 'explicit erotic act' },
];

export const EXCESSIVE_FOCUS_ON_BODY_DESCRIPTION_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const FINAL_RATING_OPTIONS = [
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
  { label: '4', value: 4 },
  { label: '5', value: 5 },
];

export const LANGUAGE_OF_SECRECY_OR_CONCEALMENT_OPTIONS = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const RELIGIOUS_KEYWORD_FOUND = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];

export const RELIGIOUS_SLANG_FOUND = [
  { label: 'True', value: true },
  { label: 'False', value: false },
];
